import { API } from '../main'
const prefix = '/carriers'

const getCarriers = () => {
    return API.get(`${prefix}/`)
}

export { getCarriers }